import React, { useEffect, useState, useRef } from 'react';
import swal from 'sweetalert2';
import noData from '../assets/images/no-data.png';
import moment from 'moment';

const imgUrl = 'https://metromatrix.s3.ap-south-1.amazonaws.com/Public/MetroMatrix/Content/';

import { addComment, deleteComment, getClientDetails, getClientList } from './api/dashboardAPI';
import { getSlots, scheduleClient } from './api/scheduledAPI';    
import { getAuthState } from '../assets/scripts/login-util';
import { downloadAndOpenPDFHandler, downloadVideoHandler } from './global/helper';

const Dashboard = (props) => {

    const colors = ['#007bff', '#adb5bd', '#17a2b8', '#02b875'];

    const [clients,             setClients]             = useState([]);
    const [comments,            setComments]            = useState([]);
    const [slots,               setSlots]               = useState([]);
    const [selectedSlot,        setSelectedSlot]        = useState(null);
    const [video,               setVideo]               = useState(null);
    const [videoURL,            setVideoURL]            = useState(null);
    const videoRef                                      = useRef(null);

    const [client,              setClient]              = useState({ID: 0});
    const [schedule,            setSchedule]            = useState(null);

    const [search,              setSearch]              = useState('');
    const [debouncedSearch,     setDebouncedSearch]     = useState('');
    const searchDebounceTimeout                         = useRef(null);

    const [auth,                setAuth]                = useState(getAuthState('user'));

    useEffect(() => {
        const videoModalElement = document.getElementById('videoModal'); 
        const handleVideoModalHide = () => {
            if (videoRef.current) {
              videoRef.current.pause();
            }
        };
        videoModalElement.addEventListener('hidden.bs.modal', handleVideoModalHide);
        return () => {
            videoModalElement.removeEventListener('hidden.bs.modal', handleVideoModalHide);
        }; 
    }, [])

    useEffect(() => {
        if (searchDebounceTimeout.current) {
            clearTimeout(searchDebounceTimeout.current);
        }

        searchDebounceTimeout.current = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => {
            if (searchDebounceTimeout.current) {
                clearTimeout(searchDebounceTimeout.current);
            }
        };
    }, [search]);

    useEffect(() => {
       fetchClients({
            search: debouncedSearch,
            status: props.status
        });
    }, [debouncedSearch, props.status])

    useEffect(() => {
        if (video) {
            const url = URL.createObjectURL(video);
            setVideoURL(url);
        }else{
            URL.revokeObjectURL(videoURL);
            setVideoURL(null);
        }
    }, [video])

    const handleDownloadPDF = (e, clientId) => {
        e.stopPropagation();
        downloadAndOpenPDFHandler(clientId);

        const modalElement = document.getElementById('viewModal');
        const closeButton = modalElement.querySelector('.btn-close');

        const closeModalAfterOpen = () => {
            closeButton.click();
            modalElement.removeEventListener('shown.bs.modal', closeModalAfterOpen);
        };

        modalElement.addEventListener('shown.bs.modal', closeModalAfterOpen);
    };

    const handleDownloadVideo = async (clientId) => {
        if (!video) {
            const videoBlob = await downloadVideoHandler(clientId);
            setVideo(videoBlob);
        }
    };

    const fetchClients = async(filters = {}) => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Clients } = await getClientList(filters);
            setClients(Clients);
            swal.close();
            return Clients;
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const refreshClients = async () => {
        await fetchClients({
            search,
            status: props.status
        });
    }

    const fetchClientDetails = async (m) => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Client, Comments, Schedule } = await getClientDetails(m.ID);
            setClient(Client);
            setComments(Comments);
            setSchedule(Schedule);
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const sendComment = async () => {
        try {

            const comment = document.getElementById('txtComment').value;
            if (comment != '') {
                await addComment({ClientID: client.ID, Comment: comment});
                document.getElementById('txtComment').value = '';
                fetchClientDetails(client);  
            }  
        } catch (err) {
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
              })
            return;  
        }  
    };

    const removeComment = async (id) => {
        try {
            await deleteComment(id);
            fetchClientDetails(client);  
        } catch (err) {
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const scheduleClientData = async () => {
        try {
        
            const date = document.getElementById('txtDate').value;            

            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });

            await scheduleClient({
                ClientID    : client.ID,
                Date        : date,
                From        : selectedSlot.From,
                To          : selectedSlot.To
            });

            document.querySelector('#scheduleModal .btn-close').click();
            swal.close();
            fetchClientDetails(client);
            await refreshClients();

        } catch (err) {
            swal.close();
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
            })
            return;  
        }  

    };

    const fillSchedule = (c) => {

        if (c.Status == "Scheduled" && schedule) {
            document.getElementById('txtDate').value = moment(schedule.Date).format('YYYY-MM-DD');
            getDoctorSlots();
        } 
    };

    const getDoctorSlots = async () => {
        try {
        
            const date = document.getElementById('txtDate').value;

            if (date) {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });

                const { Slots } = await getSlots(date);

                setSlots(Slots);
                setSelectedSlot(null);
                swal.close();
            }

        } catch (err) {
            swal.close();
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
              })
            return;  
        }  
    };

    const resetData = () => {
        setClient({ID: 0});
        setSchedule(null);
        setComments([]);
        setSlots([]);
        setSelectedSlot(null);
        setVideo(null);
    };

    const getColorForUserId = (userId) => {
        const colorIndex = userId % colors.length;
        return colors[colorIndex];
    };

    return ( 
        <>

            <div className="navbar navbar-expand-lg fixed-top margin-t58" style={{backgroundColor: '#fff', zIndex: '1'}}>
                <div className="container d-block padding-t10" style={{height: '60px'}}>
                    <div className='row mb-4'>
                        <div className='col-lg-6'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'><i className="bi bi-search"></i></span>
                                <input 
                                    onChange={({ target }) => setSearch(target.value)}
                                    value={ search || '' }
                                    className="form-control fs-16" 
                                    type="search" 
                                    placeholder="Search"
                                />
                            </div>
                        </div>
                        <div className='col-lg-6 d-none d-lg-block'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'>Status</span>
                                <select value={props.status} onChange={({ target }) =>props.setStatus(target.value)} className="form-select fs-16">
                                    <option value={'All'}>All</option>
                                    <option value={'Assigned'}>Assigned</option>
                                    <option value={'Scheduled'}>Scheduled</option>
                                    <option value={'QC Pending'}>QC Pending</option>
                                    <option value={'Success'}>Success</option>
                                </select>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div className='container margin-t150'>               
                <div className='row'>        
                    {clients.length > 0 ? clients.map((m, i) => (
                        <div className='col-md-6'>  
                            <div className={`card mb-4 mx-1`} data-bs-toggle="modal" data-bs-target="#viewModal" key={m.ID} onClick={() => fetchClientDetails(m)}>
                                
                                <div className="card-body">
                                    <h6 className="card-title">{m.Name}</h6>
                                    <span className='card-text fs-16'>
                                        <span>{m.Age ? `Age: ${m.Age} | ` : ''}Contact: {m.Contact1}{m.Contact2 ? `, ${m.Contact2}` : ''}</span><br></br>
                                        <span>{m.City ? `City: ${m.City}` : ''}{m.State ? `${m.City ? ' | ' : ''}State: ${m.State}` : ''}</span><br></br>
                                        <span>{m.Language ? `Language: ${m.Language}` : ''}{m.SumAssured ? `${m.Language ? ' | ' : ''}Sum Assured: ${m.SumAssured}` : ''}</span>
                                        {m.Type && <><br></br><span>Type: {m.Type}</span></>}
                                    </span><br></br>
                                    <span className={`badge rounded-pill bg-${m.Status == 'Success' ? 'success' : m.Status == 'QC Pending' ? 'info' : m.Status == 'Scheduled' ? 'primary' : m.Status == 'Assigned' ? 'secondary' : 'warning'} mt-3 me-2`}>{m.Status}</span> 
                                    {(m.Status == 'Success' || m.Status == 'QC Pending') && <button onClick={(e) => handleDownloadPDF(e, m.ID)} type="button" className="btn btn-outline-primary btn-sm"><i className="bi bi-filetype-pdf me-1"></i>View PDF</button>}                              
                                </div>
                                <div className="card-footer footer-white fs-16">
                                    <span>Division: {m.Division} | Branch Code: {m.BranchCode}</span>
                                </div>
                                    <div className="card-footer fs-16">
                                    <span><span className={`badge bg-${m.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{m.TestType}</span> Proposal No: {m.ProposalNo}</span>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <div className='col-12'>
                            <div className='text-center mt-5'>
                                <img src={noData} alt="image"  height="150"/>
                                <h5 className='mt-3'>No Clients!</h5>
                            </div>
                        </div>
                    )}     
                    
                </div>
            </div>

            <div id='viewModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Details</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={resetData} aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className={`card mb-4 d-none d-lg-block`}>
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="card-title">{client.Name}</h6>
                                            <span className='card-text fs-16'>
                                                <span>{client.Age ? `Age: ${client.Age} | ` : ''}Contact: {client.Contact1}{client.Contact2 ? `, ${client.Contact2}` : ''}</span><br></br>
                                                <span>{client.City ? `City: ${client.City}` : ''}{client.State ? `${client.City ? ' | ' : ''}State: ${client.State}` : ''}</span><br></br>
                                                <span>{client.Language ? `Language: ${client.Language}` : ''}{client.SumAssured ? `${client.Language ? ' | ' : ''}Sum Assured: ${client.SumAssured}` : ''}</span>
                                                {client.Type && <><br></br><span>Type: {client.Type}</span></>}
                                            </span>
                                        </div>
                                        <div>
                                            <span className={`badge rounded-pill bg-${client.Status == 'Success' ? 'success' : client.Status == 'QC Pending' ? 'info' : client.Status == 'Scheduled' ? 'primary' : client.Status == 'Assigned' ? 'secondary' : 'warning'} me-5`}>{client.Status}</span>
                                        </div>
                                    </div>
                                    <div className="card-footer d-flex justify-content-between align-items-center fs-16">
                                        <span><span className={`badge bg-${client.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{client.TestType}</span> Proposal No: {client.ProposalNo}</span>
                                        <span>Division: {client.Division} | Branch Code: {client.BranchCode}</span>
                                    </div>
                                </div>

                                <div className={`card mb-4 d-lg-none`}>
                                    <div className="card-body">
                                        <h6 className="card-title">{client.Name}</h6>
                                        <span className='card-text fs-16'>
                                            <span>{client.Age ? `Age: ${client.Age} | ` : ''}Contact: {client.Contact1}{client.Contact2 ? `, ${client.Contact2}` : ''}</span><br></br>
                                            <span>{client.City ? `City: ${client.City}` : ''}{client.State ? `${client.City ? ' | ' : ''}State: ${client.State}` : ''}</span><br></br>
                                            <span>{client.Language ? `Language: ${client.Language}` : ''}</span><br></br>
                                            <span>{client.SumAssured ? `Sum Assured: ${client.SumAssured}` : ''}</span>
                                            {client.Type && <><br></br><span>Type: {client.Type}</span><br></br></>}
                                        </span><br></br>
                                        <span className={`badge rounded-pill bg-${client.Status == 'Success' ? 'success' : client.Status == 'QC Pending' ? 'info' : client.Status == 'Scheduled' ? 'primary' : client.Status == 'Assigned' ? 'secondary' : 'warning'} mt-3 me-2`}>{client.Status}</span>                          
                                    </div>
                                    <div className="card-footer footer-white fs-16">
                                        <span>Division: {client.Division}</span><br></br>
                                        <span>Branch Code: {client.BranchCode}</span>
                                    </div>
                                     <div className="card-footer fs-16">
                                        <span><span className={`badge bg-${client.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{client.TestType}</span> Proposal No: {client.ProposalNo}</span>
                                    </div>
                                </div>

                                <div className="card border-light mb-4" 
                                    onClick={() => fillSchedule(client)}
                                    data-bs-toggle={`${client.Status == 'Assigned' || client.Status == "Scheduled" ? 'modal' : ''}`} 
                                    data-bs-target={`${client.Status == 'Assigned' || client.Status == "Scheduled" ? '#scheduleModal' : ''}`} 
                                    style={{backgroundColor: '#eff3f7', cursor: `${client.Status == 'Assigned' || client.status == 'Scheduled' ? 'pointer' : 'default'}`}}>
                                    <div className="card-body d-flex justify-content-between align-items-center ms-2">
                                        <div>
                                            <span className='fs-14 fw-semibold me-3' style={{color:'#767676'}}><i className="bi bi-clock-fill me-2" style={{color:'#4582ec'}}></i>{schedule ? (moment(schedule.Date).format('DD MMM') + ' ' + schedule.From + ' - ' + schedule.To) : 'Click here to schedule'}</span>
                                        </div>
                                    </div>
                                </div>

                                {(client.Status == 'QC Pending' || client.Status == 'Success') && (
                                    <div className='row mb-4 justify-content-center'>
                                        <div className='col-6 mb-3'>
                                            <button type="button" className="btn btn-outline-primary w-100" onClick={() => downloadAndOpenPDFHandler(client.ID)}><i className="bi bi-filetype-pdf me-2"></i>View PDF</button>
                                        </div>
                                        {(client.TestType == 'VMER' || client.TestType == 'JMER') && (
                                            <div className='col-6 mb-3'>
                                                <button type="button" className="btn btn-outline-info w-100" data-bs-toggle="modal" data-bs-target="#videoModal" onClick={() => handleDownloadVideo(client.ID)}><i className="bi bi-play-circle me-2"></i>Play Video</button>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {comments.length > 0 && comments.map((m, i) => (
                                    <div key={m.ID} className="toast show mb-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                                        <div className="toast-header">
                                            {m.Photo && m.Photo != '' ?
                                                <img src={`${imgUrl}${m.Photo}`} alt="image" className="rounded-circle me-2" width="28" height="28"/> :
                                                <div className="initial-circle me-2" style={{ backgroundColor: getColorForUserId(m.UserType == 'Doctor' ? m.UserID + 1 : m.UserID) }}>
                                                    {m.UserName[0]}
                                                </div>
                                            }
                                            <strong className="me-auto">{m.UserName} {m.UserType == 'Doctor' && <i className="fi fi-rr-stethoscope text-primary ms-1"></i>}</strong>                
                                            {(auth.id == m.UserID && m.UserType == 'Doctor') && (
                                                <button onClick={() => removeComment(m.ID)} type="button" className="btn btn-outline-danger btn-sm me-2">
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            )}
                                            <small className='fw-semibold'>{moment(m.CreatedDate).format("DD MMM hh:mm A")}</small>
                                        </div>
                                        <div className="toast-body">
                                            {m.Comment}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-between align-items-center" style={{backgroundColor:'#edf2fa'}}>
                            <input id='txtComment' type="text" className="form-control flex-grow-1 me-2" placeholder="Comments" style={{ flex: 1, marginRight: '10px' }}/>
                            <button onClick={sendComment} type="button" className="btn btn-primary"><i className="bi bi-send"></i></button>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={resetData}>Close</button>
                        </div>
                    </div>
                </div>
            </div>      

            <div id='scheduleModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Schedule Client</h6>
                            <button type="button" className="btn-close" data-bs-toggle="modal" data-bs-target="#viewModal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className='row'>
                                    <div className='col-md-12 mb-3'>
                                        <div className='input-group'>
                                            <span className='input-group-text'>Date</span>
                                            <input 
                                                onChange={getDoctorSlots}
                                                id="txtDate" 
                                                type="date" 
                                                className="form-control" 
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-3 mt-3 text-center'>
                                        {slots.length > 0 && slots.map((m, i) => (
                                            <button 
                                                key={i} 
                                                type="button" 
                                                onClick={() => setSelectedSlot({...m, Index: i})}
                                                className={`btn ${selectedSlot && selectedSlot.Index == i ? 'btn-success' : `btn-outline-${m.Status == 'Available' ? 'primary' : 'secondary disabled'}`} me-3 mt-3`}>
                                                {m.From} - {m.To}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#viewModal">Close</button>
                            {selectedSlot ? 
                                (<button onClick={scheduleClientData} type="button" className="btn btn-primary">Schedule</button>) : 
                                ''
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="videoModal"
                className="modal fade"
                tabIndex="-1"
                aria-labelledby="modalLabel"
                aria-hidden="true"
                data-bs-backdrop="static" 
                data-bs-keyboard="false"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    {videoURL && (
                        <div className="modal-content" style={{backgroundColor: '#000'}}>
                            <button style={{zIndex: '1'}} type="button" className="position-absolute top-0 end-0 m-3 bg-transparent border-0 text-white" data-bs-toggle="modal" data-bs-target="#viewModal" aria-label="Close">
                                <i className="bi bi-x-lg"></i>
                            </button>
                            <div className="modal-body p-0"> 
                                <video controls autoPlay style={{ width: "100%", height: "100%", borderRadius: '8px' }} src={videoURL} ref={videoRef} />
                            </div>
                        </div>
                    )}
                </div>
            </div>


        </>
    )

}

export default Dashboard;